import React from 'react';
import { Screen } from '../App';

interface Props {
  current: Screen;
  navigate: (s: Screen) => void;
}

const ITEMS = [
  { id: 'home', icon: '●', label: 'Bugün' },
  { id: 'bond', icon: '⌁', label: 'Bağ' },
  { id: 'memories', icon: '▧', label: 'Anılar' },
  { id: 'pet', icon: '◇', label: 'Minik' },
  { id: 'us', icon: '⌘', label: 'Biz' },
] as const;

export default function BottomNav({ current, navigate }: Props) {
  const isActive = (id: string) => {
    if (id === 'bond') return ['bond', 'question', 'mood', 'imhere'].includes(current);
    if (id === 'memories') return ['memories', 'photos', 'notes', 'music', 'timeline', 'capsule', 'map'].includes(current);
    if (id === 'pet') return ['pet', 'character-creator'].includes(current);
    if (id === 'us') return [
      'us', 'more', 'tasks', 'countdown', 'streak',
      'settings', 'date-ideas', 'wishlist', 'cycle'
    ].includes(current);
    if (id === 'home') return ['home', 'daily-flow'].includes(current);
    return current === id;
  };

  return (
    <nav className="bottom-nav">
      {ITEMS.map(item => (
        <button
          key={item.id}
          className={`nav-item ${isActive(item.id) ? 'active' : ''}`}
          onClick={() => navigate(item.id as Screen)}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
